/*eslint-disable */
import { PORTAL_APP_SUBSCRIPTION_PATH } from '@zopup/zop-shared';
import { ZopNavigationItem } from '@zopup/zop-ux-core';

export const defaultNavigation: ZopNavigationItem[] = [
    {
        id: 'home',
        title: 'navigation.home',
        type: 'basic',
        link: '/',
    },
    {
        id: 'verify',
        title: 'navigation.verify',
        tooltip: 'navigation.verify',
        type: 'basic',
        link: '/verify',
    },
    {
        id: 'for-brands',
        title: 'navigation.for-brands',
        tooltip: 'navigation.for-brands',
        type: 'basic',
        link: '/brands',
    },
    {
        id: 'about-us',
        title: 'navigation.about-us',
        tooltip: 'navigation.about-us',
        type: 'basic',
        link: '/about',
    },
];
export const compactNavigation: ZopNavigationItem[] = [
    {
        id: 'home',
        title: 'navigation.home',
        type: 'basic',
        link: '/',
    },
    {
        id: 'verify',
        title: 'navigation.verify',
        tooltip: 'navigation.verify',
        type: 'basic',
        link: '/verify',
    },
    {
        id: 'for-brands',
        title: 'navigation.for-brands',
        tooltip: 'navigation.for-brands',
        type: 'basic',
        link: '/brands',
    },
    {
        id: 'about-us',
        title: 'navigation.about-us',
        tooltip: 'navigation.about-us',
        type: 'basic',
        link: '/about',
    },
];
export const futuristicNavigation: ZopNavigationItem[] = [
    {
        id: 'home',
        title: 'navigation.home',
        type: 'basic',
        link: '/',
    },
    {
        id: 'verify',
        title: 'navigation.verify',
        tooltip: 'navigation.verify',
        type: 'basic',
        link: '/verify',
    },
    {
        id: 'for-brands',
        title: 'navigation.for-brands',
        tooltip: 'navigation.for-brands',
        type: 'basic',
        link: '/brands',
    },
    {
        id: 'about-us',
        title: 'navigation.about-us',
        tooltip: 'navigation.about-us',
        type: 'basic',
        link: '/about',
    },
];
export const horizontalNavigation: ZopNavigationItem[] = [
    {
        id: 'home',
        title: 'navigation.home',
        type: 'basic',
        link: '/',
    },
    {
        id: 'verify',
        title: 'navigation.verify',
        tooltip: 'navigation.verify',
        type: 'basic',
        link: '/verify',
    },
    {
        id: 'for-brands',
        title: 'navigation.for-brands',
        tooltip: 'navigation.for-brands',
        type: 'basic',
        link: '/brands',
    },
    {
        id: 'about-us',
        title: 'navigation.about-us',
        tooltip: 'navigation.about-us',
        type: 'basic',
        link: '/about',
    },
];

export const footerNavigation: ZopNavigationItem[] = [
    {
        id: 'product',
        title: 'navigation.product',
        type: 'group',
        children: [
            {
                id: 'home',
                title: 'navigation.home',
                type: 'basic',
                link: '/',
            },
            {
                id: 'Inflewz',
                title: 'Inflewz',
                type: 'basic',
                link: 'https://inflewz.com',
                target: '_blank',
                externalLink: true,
            },
        ],
    },
    {
        id: 'company',
        title: 'navigation.company',
        type: 'group',
        children: [
            {
                id: 'about-us',
                title: 'navigation.about-us',
                type: 'basic',
                link: '/about',
            },
            {
                id: 'for-brands',
                title: 'navigation.for-brands',
                type: 'basic',
                link: '/brands',
            },
        ],
    },
    {
        id: 'legal',
        title: 'navigation.legal',
        type: 'group',
        children: [
            {
                id: 'terms-of-service',
                title: 'navigation.terms-of-service',
                type: 'basic',
                link: '/terms-of-service',
            },
            {
                id: 'privacy-policy',
                title: 'navigation.privacy-policy',
                type: 'basic',
                link: '/privacy-policy',
            },
            {
                id: 'cookies-policy',
                title: 'navigation.cookies-policy',
                type: 'basic',
                link: '/cookie-policy',
            },
        ],
    },
];

export const socialNavigation: ZopNavigationItem[] = [
    {
        id: 'inflewz',
        title: 'Inflewz',
        type: 'basic',
        icon: 'feather:link',
        link: 'https://inflewz.com',
    },
    {
        id: 'twitter',
        title: 'Twitter',
        type: 'basic',
        icon: 'feather:twitter',
        link: 'https://twitter.com',
    },
    {
        id: 'youtube',
        title: 'YouTube',
        type: 'basic',
        icon: 'feather:youtube',
        link: 'https://youtube.com',
    },
    {
        id: 'linkedin',
        title: 'LinkedIn',
        type: 'basic',
        icon: 'feather:linkedin',
        link: 'https://linkedin.com',
    },
];
